<template>
  <div>
    <a-card title="采购入库">
      <a-row :gutter="16">
        <a-col :span="24" :md="8" :xl="6" style="max-width: 256px; margin-bottom: 12px;">
          <a-input-search v-model="searchForm.search" placeholder="单号,供应商编号/名称" allowClear @search="search" />
        </a-col>
        <!-- <a-col :span="4"> <a-button type="primary" @click="onExport">导出</a-button></a-col> -->
        <a-col :span="5" style="max-width: 256px; margin-bottom: 12px">
          <a-select placeholder="选择供应商" style="width: 100%;" allowClear @change="handleSupplierChange">
            <a-select-option v-for="supplier in supplierOptions" :key="supplier" :value="supplier">
              {{ supplier }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="5" style=" margin-bottom: 12px">
          <a-row type="flex">
            <a-col :span="11">
              <a-month-picker style="width: 100px;" valueFormat="YYYY-MM" :format="monthFormat"
                :defaultValue="defaultMonth" @change="onChangePicker" placeholder="选择月份" />
            </a-col>
            <a-col :span="4"> <a-button type="primary" @click="onExport">导出</a-button></a-col>
            <!--                      <a-range-picker v-model="searchForm.date" format="YYYY-MM-DD"  @change="changeRangeDate"/>-->
          </a-row>

        </a-col>

        <a-col :span="4">
          <div>采购总数量：{{ filteredTotals.quantity.toFixed(2) }}</div>
        </a-col>

        <a-col :span="4">
          <div>采购总金额： {{ filteredTotals.amount.toFixed(2) }}</div>
        </a-col>

      </a-row>

      <a-row style="margin-top: 12px;">
        <a-table size="small" :columns="columns" :dataSource="filteredItems" rowKey="id" :loading="loading"
          :pagination="pagination" @change="tableChange" :scroll="{ x: 1700, y: 575 }">
          <div slot="action" slot-scope="value, item">
            <a-button-group size="small">
              <a-button size="small" @click="copyRecord(item)">复制</a-button>
              <a-button size="small" @click="detial(item)">详情</a-button>
              <a-popconfirm title="确定作废吗" @confirm="voidItem(item)">
                <a-button v-if="!item.is_void" type="danger" size="small">作废</a-button>
                <a-button v-else disabled size="small">已作废</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { purchaseOrderList, purchaseOrdersVoid } from '@/api/purchasing'
import { ChangePicker } from "@/utils/excel";

export default {
  name: 'Warehouse',
  components: {
  },
  data() {
    return {
      monthFormat: 'YYYY-MM',
      defaultMonth: this.getLastMonth(),
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: (value, item, index) => {
            return index + 1
          },
          width: '5%'
        },
        {
          title: '采购编号',
          dataIndex: 'number',
          sorter: true,
          width: '12%'
        },
        {
          title: '供应商',
          dataIndex: 'supplier_name',
          width: '15%'
        },
        {
          title: '商品名称',
          dataIndex: 'goods_name',
          scopedSlots: { customRender: 'goods_name' },
          width: 190
        },
        {
          title: '经手人',
          dataIndex: 'handler_name',
          width: '8%'
        },
        {
          title: '发生日期',
          dataIndex: 'handle_time',
          width: '8%'
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'create_time',
        //   width: '12%'
        // },
        {
          title: '采购总数量',
          dataIndex: 'total_quantity',
          width: '8%'
        },
        {
          title: '采购总金额',
          dataIndex: 'total_amount',
          width: '8%'
        },
        {
          title: '付款金额',
          dataIndex: 'payment_amount',
          width: '8%'
        },
        {
          title: '其他费用',
          dataIndex: 'other_amount',
          width: '8%'
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
          width: '150px'  // 添加明确的宽度值
        },
      ],
      searchForm: { page: 1, page_size: 50 }, //page: 1, page_size: 16
      pagination: { current: 1, total: 0, pageSize: 50 },
      loading: false,
      items: [],
      visible: false,
      targetItem: {},
      form: {},
      total_amounts: 0,
      total_quantitys: 0,
      supplierFilter: '', // 添加供应商筛选值
    };
  },
  computed: {
    filteredItems() {
      if (!this.supplierFilter) {
        return this.items;
      }
      return this.items.filter(item =>
        item.supplier_name === this.supplierFilter
      );
    },

    // 获取所有不重复的供应商名称
    supplierOptions() {
      const suppliers = new Set();
      this.items.forEach(item => {
        if (item.supplier_name) {
          suppliers.add(item.supplier_name);
        }
      });
      return Array.from(suppliers);
    },

    // 计算过滤后的总金额和总数量
    filteredTotals() {
      let totalAmount = 0;
      let totalQuantity = 0;

      this.filteredItems.forEach(item => {
        if (!item.is_void) {
          totalAmount += parseFloat(item.total_amount || 0);
          totalQuantity += parseFloat(item.total_quantity || 0);
        }
      });

      return {
        amount: totalAmount,
        quantity: totalQuantity
      };
    }
  },
  methods: {
    // 获取上个月的方法
    getLastMonth() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      return `${year}-${month}`;
    },
    // 供应商选择变更
    handleSupplierChange(value) {
      this.supplierFilter = value;
    },
    onChangePicker(a, b) {
      if (a == null) {
        this.searchForm.start_date = a;
        this.searchForm.end_date = a;
        this.search();
        return;
      }
      const { first_day1, last_day1 } = ChangePicker(a, b)
      this.searchForm.start_date = first_day1;
      this.searchForm.end_date = last_day1;
      this.search();
    },


    onExport() {
      import("../../../utils/xlsx.js").then((excel) => {
        //tHeader 为导出后的表头
        let tHeader = [], filterVal = [], list = []

        tHeader = ["采购编号", "商品名称", "供应商", "经手人", "录入时间", "发生日期", "采购总数量", "采购总金额", "付款金额", "其他费用", "备注",];
        filterVal = ["number", "goods_name", "supplier_name", "handler_name", "create_time", "handle_time", "total_quantity", "total_amount", "payment_amount", "other_amount", "remark",];
        list = this.exportItems
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: `采购出库列表` + this.getCurrentDate(),
          autoWidth: true,
          bookType: "xlsx",
        });
      });

    },

    getCurrentDate() {
      let today = new Date();
      let year = today.getFullYear();
      let month = (today.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要+1，并且补0到两位数
      let day = today.getDate().toString().padStart(2, '0'); // 补0到两位数
      let formattedDate = `${year}${month}${day}`; // 拼接年月日
      return formattedDate;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },

    // changeRangeDate( param = this.defaultExtraParam){
    //   console.log(4444,param)
    //   // debugger
    //   this.searchForm.start_date=param + '-01'
    //   this.searchForm.end_date=param + '-31'
    //   this.search()
    // },

    initialize() {
      // 设置初始搜索条件为上个月
      const { first_day1, last_day1 } = ChangePicker(this.defaultMonth);
      this.searchForm.start_date = first_day1;
      this.searchForm.end_date = last_day1;

      this.list();
    },
    list() {
      this.loading = true;
      purchaseOrderList(this.searchForm).then(data => {
        this.pagination.total = data.count;
        this.items = data.results;
        this.total_amounts = 0
        this.total_quantitys = 0
        this.exportItems = []
        this.items.forEach(item => {
          const obj = item
          obj.total_amount = parseFloat(item.total_amount)
          obj.other_amount = parseFloat(item.other_amount)
          obj.payment_amount = parseFloat(item.payment_amount)
          obj.goods_name = item.purchase_goods_items && item.purchase_goods_items.length > 0 ? item.purchase_goods_items[0].goods_name : ''

          this.total_amounts = this.total_amounts + obj.total_amount
          this.total_quantitys = this.total_quantitys + obj.total_quantity


          this.exportItems.push(obj)
        })

      }).finally(() => {
        this.loading = false;
      });
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.searchForm.page_size = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      if (sorter && sorter.field && sorter.order) {
        this.searchForm.ordering = `${sorter.order == 'descend' ? '-' : ''}${sorter.field}`;
      } else {
        delete this.searchForm.ordering;
      }
      this.list();
    },

    search() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    detial(item) {
      this.$router.push({ path: '/purchasing/purchase_record_detail', query: { id: item.id } });
    },
    copyRecord(item) {
      // 复制采购记录,跳转到新增页面并带上数据
      const copiedData = {
        supplier_id: item.supplier,
        supplier_name: item.supplier_name,
        handler: item.handler,
        warehouse: item.warehouse,
        account: item.account,
        payment_amount: item.payment_amount,
        handle_time: item.handle_time,
        remark: item.remark,
        // 复制商品明细
        purchase_goods_items: item.purchase_goods_items ? item.purchase_goods_items.map(goods => ({
          goods: goods.goods,
          goods_name: goods.goods_name,
          goods_number: goods.goods_number,
          goods_spec: goods.goods_spec,
          unit: goods.unit,
          unit_name: goods.unit_name,
          quantity: goods.purchase_quantity,
          price: goods.purchase_price,
          total_amount: goods.total_amount
        })) : []
      };
      
      this.$router.push({ 
        path: '/purchasing/purchase_create', 
        query: { copyData: JSON.stringify(copiedData) }
      });
      this.$message.success('正在复制记录...');
    },
    voidItem(item) {
      purchaseOrdersVoid({ id: item.id }).then(() => {
        this.$message.success('作废成功');
        this.list();
      }).catch(() => {
        this.list();
      });
    },
  },
  mounted() {
    this.initialize();
  },
}
</script>
